export enum ShippingMethodCode {
  InPostParcelLocker = 'INPOST_PACZKOMATY',
  InPostInternationalParcelLocker = 'INPOST_INTERNATIONAL_PACZKOMATY',
  MondialRelayInternational = 'MONDIAL_RELAY_INTERNATIONAL',
  InPostCourier = 'INPOST',
  InPostInternationalCourier = 'INPOST_INTERNATIONAL',
  InPostCashOnDelivery = 'INPOST_COD',
  DHL = 'DHL',
  ELECTRONIC = 'ELECTRONIC',
  Przelewy24 = 'PRZELEWY24',
  Cinkciarz = 'CINKCIARZ',
  CinkciarzBlik = 'CINKCIARZ_BLIK',
}
